var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"twitter"),React.createElement("path",{"d":"M77.4,200c92.9,0,143.7-76.9,143.7-143.6c0-2.2-0.1-4.4-0.1-6.5c9.9-7.2,18.4-16,25.2-26.1c-9.2,4.1-19,6.8-29,8\r\n\tc10.6-6.3,18.4-16.3,22.2-28c-9.9,5.9-20.8,10.1-32.1,12.3c-19.1-20.3-51.1-21.3-71.4-2.2c-13.1,12.3-18.7,30.7-14.6,48.2\r\n\tC80.6,60,42.8,40.8,17.1,9.3C3.7,32.3,10.6,61.8,32.8,76.7c-8-0.2-15.9-2.4-22.9-6.3c0,0.2,0,0.4,0,0.7c0,24,17,44.7,40.5,49.5\r\n\tc-4.3,1.2-8.8,1.8-13.3,1.8c-3.2,0-6.4-0.3-9.5-0.9c6.6,20.6,25.6,34.7,47.2,35.1c-17.9,14-40,21.6-62.8,21.6c-4,0-8-0.2-12-0.7\r\n\tC23.1,192.1,49.9,200,77.4,200","key":1})]);
}

Twitter.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"246.1px","height":"200px","viewBox":"0 0 246.1 200","style":{"enableBackground":"new 0 0 246.1 200"},"xmlSpace":"preserve"};

module.exports = Twitter;

Twitter.default = Twitter;
